/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function OrganicIcon({ size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      viewBox="0 -3 33 40"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <text
          fill="#979797"
          fontFamily="SourceSansPro-Semibold, Source Sans Pro"
          fontSize="6"
          fontWeight="500"
        >
          <tspan x="3.12" y="35.5">
            ORGANIC
          </tspan>
        </text>
        <g stroke="#979797" transform="translate(.5 .5)">
          <path d="M18.167 7a8.78 8.78 0 01-4.935 14.069l-2.414.537h0l-.892-2.062A8.98 8.98 0 0118.167 7h0z"></path>
          <path d="M15.5 11.317a5.678 5.678 0 003.753-1.416l.247-.218h0"></path>
          <path d="M18.167 7l-.264.386a53 53 0 00-6.51 13.035L11.03 21.5h0"></path>
          <path d="M13.817 14.5h.042c2.084 0 4.153-.355 6.117-1.051h0"></path>
          <path d="M12.417 18c2.042 0 4.071-.327 6.01-.97l.31-.103h0"></path>
          <path d="M15.5 11l-.076-.114A5.514 5.514 0 0114.5 7.83h0"></path>
          <path d="M13.817 14.303a14.183 14.183 0 01-2.144-4.027L11.579 10h0"></path>
          <path d="M12.417 18a30.45 30.45 0 01-2.368-4.688l-.182-.452h0"></path>
          <circle cx="14.5" cy="14.5" r="14.5"></circle>
        </g>
      </g>
    </svg>
  );
}
